import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import React, { useEffect } from 'react'
import { FiSettings } from 'react-icons/fi';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import ThemeSettings from './ThemeSettings';
import Footer from './Footer';
import { useStateContext } from '../contexts/ContextProvider';

export default function Skeleton(props) {
    const { setCurrentColor, setCurrentMode, currentMode, activeMenu, currentColor, themeSettings, setThemeSettings, setCurrentProfile } = useStateContext();

    useEffect(() => {
        const currentThemeColor = localStorage.getItem('colorMode');
        const currentThemeMode = localStorage.getItem('themeMode');
        const currentProfile = localStorage.getItem('currentProfile');
        if (currentThemeColor && currentThemeMode && currentProfile) {
            setCurrentColor(currentThemeColor);
            setCurrentMode(currentThemeMode);
            setCurrentProfile(currentProfile);
        }
    }, []);

    return (
        <div className={currentMode === 'Dark' ? 'dark' : ''}>
            <div className="flex relative dark:bg-main-dark-bg">
                <div className="fixed right-4 bottom-4" style={{ zIndex: '1000' }}>
                    <TooltipComponent
                        content="Settings"
                        position="Top"
                    >
                        <button
                            type="button"
                            onClick={() => setThemeSettings(true)}
                            style={{ background: currentColor, borderRadius: '50%' }}
                            className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                        >
                            <FiSettings />
                        </button>

                    </TooltipComponent>
                </div>
                {activeMenu ? (
                    <div className="fixed sidebar dark:bg-secondary-dark-bg bg-white w-72">
                        <Sidebar />
                    </div>
                ) : (
                    <div className="w-0 dark:bg-secondary-dark-bg">
                        <Sidebar />
                    </div>
                )}
                <div
                    className={
                        activeMenu
                            ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full'
                            : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
                    }
                >
                    <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
                        <Navbar />
                    </div>
                    <div>
                        {themeSettings && (<ThemeSettings />)}

                        {props.children}
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}
